<!--
  Light-theme icon.

  Deliberately NOT FontAwesome. The free `sun` glyph — regular and solid alike —
  is a disc ringed by wavy rays that touch it, and at the 20px this renders at
  that silhouette reads as a cog: the same shape as every settings control in
  the app. This is the classic sun instead — a plain disc with eight detached
  straight rays — which nothing else here can be mistaken for.

  Stroke is 1.6 on a 24 grid (≈32/512), FontAwesome's regular weight, so it
  pairs evenly with the `faMoon` it toggles against.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="4.2" />
    <path
      d="M12 1.6V4.4M12 19.6V22.4M1.6 12H4.4M19.6 12H22.4M4.65 4.65 6.63 6.63M19.35 4.65 17.37 6.63M19.35 19.35 17.37 17.37M4.65 19.35 6.63 17.37"
    />
  </svg>
</template>
